import React from "react";

export default function ColorFrame42({ fill, frameTextToggle, children }) {
  return (
    <svg
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      width="300"
      height="300"
      viewBox="0 0 300 300"
    >
      <g transform={frameTextToggle}>
        <circle
          cx="138.295"
          cy="34.295"
          r="25.929"
          stroke={fill}
          strokeWidth="14.732"
        ></circle>
        <mask
          id="mask0_2256_161797"
          style={{ maskType: "alpha" }}
          width="67"
          height="67"
          x="105"
          y="1"
          maskUnits="userSpaceOnUse"
        >
          <circle
            cx="138.295"
            cy="34.295"
            r="25.929"
            stroke={fill}
            strokeWidth="14.732"
          ></circle>
        </mask>
        <g mask="url(#mask0_2256_161797)">
          <path
            stroke={fill}
            strokeWidth="14.732"
            d="M181.902 53.741c0 7.212-4.032 14.403-11.878 20.073-7.836 5.662-19.03 9.391-31.729 9.391-12.699 0-23.893-3.73-31.729-9.391-7.846-5.67-11.878-12.861-11.878-20.073s4.032-14.403 11.878-20.072c7.836-5.662 19.03-9.392 31.729-9.392 12.699 0 23.893 3.73 31.729 9.392 7.846 5.669 11.878 12.86 11.878 20.072z"
            opacity="0.5"
          ></path>
        </g>
        <path
          fill={fill}
          d="M43.125 23.753a7.071 7.071 0 015.526-6.901l25.34-5.673c4.419-.99 8.616 2.372 8.616 6.9v187.403a7.071 7.071 0 01-7.071 7.072h-25.34a7.072 7.072 0 01-7.071-7.072V23.752zM232.875 23.753a7.071 7.071 0 00-5.527-6.901l-25.339-5.673c-4.419-.99-8.616 2.372-8.616 6.9v187.403a7.071 7.071 0 007.071 7.072h25.34a7.071 7.071 0 007.071-7.072V23.752z"
        ></path>
        <mask
          id="mask1_2256_161797"
          style={{ maskType: "alpha" }}
          width="40"
          height="202"
          x="43"
          y="11"
          maskUnits="userSpaceOnUse"
        >
          <path
            fill={fill}
            d="M43.125 23.753a7.071 7.071 0 015.526-6.901l25.34-5.673c4.419-.99 8.616 2.372 8.616 6.9v187.403a7.071 7.071 0 01-7.071 7.072h-25.34a7.072 7.072 0 01-7.071-7.072V23.752z"
          ></path>
        </mask>
        <g mask="url(#mask1_2256_161797)">
          <path
            fill={fill}
            d="M31.517 77.47c-.115-1.626.334-3.24 1.354-4.513 3.565-4.448 13.247-15.44 27.933-23.93 9.31-5.382 17.47-9.256 23.347-11.8 4.577-1.98 9.363 1.576 9.096 6.556l-10.28 191.542a7.072 7.072 0 01-7.062 6.693h-26.19a7.072 7.072 0 01-7.054-6.574L31.517 77.471z"
            opacity="0.5"
          ></path>
        </g>
        <mask
          id="mask2_2256_161797"
          style={{ maskType: "alpha" }}
          width="40"
          height="202"
          x="193"
          y="11"
          maskUnits="userSpaceOnUse"
        >
          <path
            fill={fill}
            d="M232.875 23.753a7.071 7.071 0 00-5.527-6.901l-25.339-5.673c-4.419-.99-8.616 2.372-8.616 6.9v187.403a7.071 7.071 0 007.071 7.072h25.34a7.071 7.071 0 007.071-7.072V23.752z"
          ></path>
        </mask>
        <g mask="url(#mask2_2256_161797)">
          <path
            fill={fill}
            d="M244.483 77.47c.115-1.626-.334-3.24-1.354-4.513-3.565-4.448-13.247-15.44-27.933-23.93-9.309-5.382-17.47-9.256-23.347-11.8-4.577-1.98-9.363 1.576-9.096 6.556l10.281 191.542a7.071 7.071 0 007.061 6.693h26.19a7.073 7.073 0 007.054-6.574l11.144-157.973z"
            opacity="0.5"
          ></path>
        </g>
        <path
          fill={fill}
          d="M39 122.982c0-54.676 44.324-99 99-99s99 44.324 99 99v131.411c0 11.391-9.234 20.625-20.625 20.625H59.625c-11.39 0-20.625-9.234-20.625-20.625V122.982z"
        ></path>
        <mask
          id="mask3_2256_161797"
          style={{ maskType: "alpha" }}
          width="198"
          height="253"
          x="39"
          y="23"
          maskUnits="userSpaceOnUse"
        >
          <path
            fill={fill}
            d="M39 122.982c0-54.676 44.324-99 99-99s99 44.324 99 99v131.411c0 11.391-9.234 20.625-20.625 20.625H59.625c-11.39 0-20.625-9.234-20.625-20.625V122.982z"
          ></path>
        </mask>
        <g mask="url(#mask3_2256_161797)">
          <path
            fill={fill}
            d="M39 274.008a5.767 5.767 0 015.767-5.767h186.466a5.767 5.767 0 015.767 5.767 1.01 1.01 0 01-1.009 1.01H40.009a1.01 1.01 0 01-1.009-1.01z"
            opacity="0.5"
          ></path>
        </g>
        <path
          stroke="#3A4CEB"
          strokeLinecap="round"
          strokeOpacity="0.5"
          strokeWidth="5.304"
          d="M216.375 117.089v0c0-41.658-33.771-75.428-75.429-75.428h-5.892c-41.659 0-75.429 33.77-75.429 75.428v0"
        ></path>
        <path
          fill="#77E7FF"
          d="M69.643 213.143c0-11.391 9.234-20.625 20.625-20.625h95.464c11.391 0 20.625 9.234 20.625 20.625v24.161c0 11.39-9.234 20.625-20.625 20.625H90.268c-11.391 0-20.625-9.235-20.625-20.625v-24.161z"
        ></path>
        <mask
          id="mask4_2256_161797"
          style={{ maskType: "alpha" }}
          width="138"
          height="66"
          x="69"
          y="192"
          maskUnits="userSpaceOnUse"
        >
          <path
            fill="#77E7FF"
            d="M69.643 213.143c0-11.391 9.234-20.625 20.625-20.625h95.464c11.391 0 20.625 9.234 20.625 20.625v24.161c0 11.39-9.234 20.625-20.625 20.625H90.268c-11.391 0-20.625-9.235-20.625-20.625v-24.161z"
          ></path>
        </mask>
        <g mask="url(#mask4_2256_161797)">
          <path
            fill="#77E7FF"
            d="M68.99 256.625c-.783-1.567.357-3.411 2.11-3.411h131.443c.892 0 1.709.505 2.108 1.303.784 1.567-.356 3.411-2.108 3.411H71.099a2.356 2.356 0 01-2.108-1.303z"
          ></path>
        </g>
        <path
          fill="#3A4CEB"
          d="M82.607 209.902a2.652 2.652 0 012.652-2.652h105.482a2.652 2.652 0 110 5.304H85.259a2.652 2.652 0 01-2.652-2.652zM186.91 219.625a2.357 2.357 0 01-2.357-2.357v-4.714h4.715v4.714a2.358 2.358 0 01-2.358 2.357z"
          opacity="0.5"
        ></path>
        <rect
          width="110.786"
          height="110.786"
          x="82.607"
          y="62.875"
          fill="#fff"
          stroke="#77E7FF"
          strokeWidth="4.714"
          rx="55.393"
        ></rect>
        {children}
      </g>
    </svg>
  );
}
